import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    title: 'Follow-up of beneficial owners',
  },
  fr: {
    title: 'Suivi des bénéficiaires effectifs',
  },
} as const);
